const accountinfo = {
    state: {
      draftUploadFiles:[]
    },
    mutations: {
      changeDraftUploadFiles (state, data) {
        state.draftUploadFiles = data
      }
    },
    actions: {
      updateDraftUploadFiles(context, data) {
        context.commit("changeDraftUploadFiles", data)
      }
    },
    getters: {
    }
  }

  export default accountinfo
